import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import cogoToast from "cogo-toast";
import SequenceManager from "../../components/SequenceManager/SequenceManager";
import { makeStyles } from "@material-ui/core/styles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    marginTop: "20px",
  },
}));

const SequenceManagerPage = () => {
  const classes = useStyles();
  const [dynamicRoutes, setDynamicRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [userPageAccess, setUserPageAccess] = useState([]);

  // useEffect(() => {
  //   getNewUserAccess();
  // }, []);

  useEffect(() => {
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    getNewUserAccess();

    const refreshSidebar = () => {
      getNewUserAccess();
    };

    window.addEventListener("refreshSidebar", refreshSidebar);

    return () => {
      window.removeEventListener("refreshSidebar", refreshSidebar);
    };

  }, []);

  const getNewUserAccess = async () => {
    let params = {
      UserId: localStorage.getItem("Infodata"),
      ServiceType: "Sidebar",
    };
    try {
      const response = await api.post(APIConstant.path.getUserAccessEquator, params);
      if (response.success) {
        let routesdata = response.data;
        let routesObj = [];

        for (let i = 0; i < routesdata.length; i++) {
          let Obj = {};
          if (
            routesdata[i].ServiceName === "Add Ware House" ||
            routesdata[i].ServiceName === "View Ware House" ||
            routesdata[i].ServiceName === "Add Stock" ||
            routesdata[i].ServiceName === "Add Inward Stock" ||
            routesdata[i].ServiceName === "View Inward Stock" ||
            routesdata[i].ServiceName === "Add Outward Stock" ||
            routesdata[i].ServiceName === "View Outward Stock"
          ) {
            Obj.invisible = false;
          }
          Obj.path = routesdata[i].Path;
          Obj._id = routesdata[i]._id;
          Obj.name = routesdata[i].ServiceName;
          Obj.icon = routesdata[i].icon;
          Obj.collapse = routesdata[i].Path == "" ? true : false;
          Obj.collapseActive = routesdata[i].Path == "" ? true : false;
          // Obj.component = Components[routesdata[i].Component]
          Obj.layout = routesdata[i].Layout;

          if (routesdata[i].Path === "") {
            let views = routesdata[i].SubServices || [];
            let child = [];

            for (let j = 0; j < views.length; j++) {
              let childObj = {};
              childObj.path = views[j].Path;
              childObj.name = views[j].ServiceName;
              childObj.icon = views[j].icon;
              childObj.layout = views[j].Layout;
              child.push(childObj);
            }
            Obj.views = child;
          }
          routesObj.push(Obj);
        }
        setDynamicRoutes(routesObj);
      }
      setLoading(false);
    } catch (err) {
      console.log("Error: ", err);
      setLoading(false);
    }
  };

  const handleSequenceSave = async (items) => {
    try {
      const params = { sequences: items };
      api
        .post(APIConstant.path.updateServiceSequence, params)
        .then((res) => {
          if (res.Success || res.success) {
            // getNewUserAccess(); // refresh
            // 🔥 sidebar ko refresh karne ka event
            window.dispatchEvent(new Event("refreshSidebar"));
            cogoToast.success("Sequence updated successfully");
          } else {
            cogoToast.error(res.message || "Sequence update failed");
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const itemsToShow = dynamicRoutes?.filter(item => item?.invisible !== false);

  return (
    <div className={classes.root}>
      {userPageAccess?.includes("View") && (
        <SequenceManager
          initialItems={itemsToShow}
          onSave={handleSequenceSave}
        />
      )}
    </div>
  );
};

export default SequenceManagerPage;
